import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';

export const defaultModalProps: ModalDialogProps = {
	width: '395px',
};
